import { useMemo } from 'react';
import useAuth from 'hooks/useAuth';
import { useEffect } from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import { dispatch, RootState, useSelector } from 'store';
import { setLastSaved } from 'store/reducers/ui';
import { STAFF_LIKE_ACCOUNT_TYPES } from 'constants/optionLists';
import AnonRoutes from './AnonRoutes';
import ClientRoutes from './ClientRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import PublicRoutes from './PublicRoutes';
import TalentRoutes from './TalentRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const { user } = useAuth() || {};
  const location = useLocation();
  const { accountTypes } = user || {};
  const { viewRoute } = useSelector((state: RootState) => state.config.userConfig) || {};

  useEffect(() => {
    dispatch(setLastSaved(null));
  }, [location]);

  const staff = useMemo(() => [LoginRoutes, PublicRoutes, MainRoutes], []);
  const talent = useMemo(() => [LoginRoutes, PublicRoutes, TalentRoutes, { path: '*', element: <></> }], []);
  const client = useMemo(() => [LoginRoutes, PublicRoutes, ClientRoutes, { path: '*', element: <></> }], []);
  const anon = useMemo(() => [LoginRoutes, PublicRoutes, AnonRoutes], []);

  const staffRoutes = useRoutes(staff);
  const talentRoutes = useRoutes(talent);
  const clientRoutes = useRoutes(client);
  const anonRoutes = useRoutes(anon);

  if (
    STAFF_LIKE_ACCOUNT_TYPES.some((type) => accountTypes?.includes(type))
  ) {
    if (viewRoute === 'Talent') return talentRoutes;
    if (viewRoute === 'Client') return clientRoutes;
    return staffRoutes;
  }

  if (accountTypes?.includes('Talent')) return talentRoutes;

  if (accountTypes?.includes('Client')) return clientRoutes;

  return anonRoutes;
}
